(ns nl.mediquest.questionnaire-frontend.util.lazy
  (:require-macros nl.mediquest.questionnaire-frontend.util.lazy)
  (:require
   [reagent.core :as r]
   [shadow.cljs.modern :refer (js-await)]
   [shadow.lazy :as lazy]))

(defn lazy-component*
  "Inspired by: https://github.com/fricze/code-splitting-clojurescript"
  [loadable-component]
  (fn []
    (let [component (r/atom (constantly nil))]
      (js-await
       [loaded-component (lazy/load loadable-component)]
       (reset! component loaded-component))
      (fn [props]
        [@component props]))))
